/* template */
<template><div class="main-goods-list" v-if="(cates.length)"><cates-tab :cates="(cates)" :active="(active)" @change-cate="onCateChange" ref="tab"/><div :style="({      'min-height': `${contentMinHeight}px`    })" class="goods-list-content"><cate-goods-list :cate="(active)" v-if="(active !== 0)"/><template v-else-if="(cates.length)"><all-by-algorithm-goods-list :has-recommend="(hasRecommend)" v-if="(testOldList)"/><all-by-cate-goods-list :cates="(cates)" :has-recommend="(hasRecommend)" v-else/></template></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mcae6158a"}'>
.main-goods-list
  width 750rpx
.goods-list-content
  padding 0 0 20rpx 33rpx
  background-color #F0ECEC
  background-image linear-gradient(0deg, #F0ECEC 36%, #FEF5F5 72%, #FFFDFD 88%)
  margin-top -1px
  padding-bottom: calc(constant(safe-area-inset-bottom) + 22rpx)
  padding-bottom: calc(env(safe-area-inset-bottom) + 22rpx)
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
import { TrackMap } from '../../../lib/webx/common_methods/track_map'

createComponent({
  name: 'MainGoodsList',
  properties: {
    cates: {
      required: true,
      type: Array,
    },
    activeCate: Number,
    testOldList: {
      type: Boolean,
      value: false,
    },
    hasRecommend: {
      type: Boolean,
      value: false,
    },
  },
  watch: {
    cates: {
      handler: function(n) {
        if (this.activeCate !== undefined) {
          this.active = this.activeCate
        }
        if (n.length) {
          this.$nextTick(() => {
            const { bottom = 0 } = this.$refs.tab?.$el?.getBoundingClientRect() || {}
            this.contentMinHeight =  bottom ? window.innerHeight - bottom + 1 : 200
          })
          TrackMap.index.tabExposed(n.slice(0, 6).map(item => item.id))
        }
      },
      deep: true,
    },
  },
  data: {
    active: 0,
    contentMinHeight: 200,
  },
  methods: {
    onCateChange({ detail }) {
      this.cateGoods = []
      this.active = detail
      TrackMap.index.changeTab(detail)
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "indexcae6158a",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'cates-tab':getComponent(require("./components/tabs.mpx?component=true&componentId=tabs85698380")),'cate-in-list':getComponent(require("./components/cate_in_list.mpx?component=true&componentId=cate_in_list57520d6c")),'cate-goods-list':getComponent(require("./components/cate_goods_list.mpx?component=true&componentId=cate_goods_list25d9b343")),'all-by-algorithm-goods-list':getComponent(require("./components/all_by_algorithm_goods_list.mpx?component=true&componentId=all_by_algorithm_goods_list1db71026")),'all-by-cate-goods-list':getComponent(require("./components/all_by_cate_goods_list.mpx?component=true&componentId=all_by_cate_goods_list4bb590cf"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
